import NProgress from 'nprogress'  // 进度条
import 'nprogress/nprogress.css'
import { useLoginStore } from '@/store/modules/userlogin'
import { roleRoutes } from './permission'

// 白名单：不需要登录就能访问的路由
const whiteList = ['/login','/register']

export function setupRouterGuard(router) {
  // 配置进度条
  NProgress.configure({ showSpinner: false })

  // 路由前置守卫
  router.beforeEach(async (to, from, next) => {
    const store = useLoginStore()  //  store 的初始化
    
    NProgress.start()
    console.log('当前路径:', to.path)  // 添加日志
    console.log('是否有token:', !!store.token)  // 添加日志
    
    const token = store.token
    const message = store.message
    
    // 检查是否是登录凭证失效
    if (message === '登录凭证失效' || !token) {
      console.log('进入无token分支')  // 添加日志
      if (whiteList.includes(to.path)) {
        next()
      } else {
        // 保存原始目标路由
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    } else if (token) {
      console.log('进入有token分支')
      const userInfoStr = localStorage.getItem('userInfo')
      console.log('原始 userInfo:', userInfoStr)
      
      let userRoles = []
      try {
        userRoles = JSON.parse(userInfoStr).split(',')
        console.log('解析后的用户角色数组:', userRoles)
      } catch (error) {
        console.error('角色解析错误:', error)
        userRoles = []
      }

      // 如果当前在登录页面，处理重定向
      if (to.path === '/login') {
        const redirectPath = to.query.redirect
        console.log('登录页面检测到重定向路径:', redirectPath)
        
        if (redirectPath && checkRoutePermission(redirectPath, userRoles)) {
          console.log('执行重定向到:', redirectPath)
          next({ path: redirectPath, replace: true, query: {} }) // 清除 query 参数
          return
        } else {
          next({ path: '/DefaultContent', replace: true })
          return
        }
      }
      
      // 检查当前路径权限
      if (!checkRoutePermission(to.path, userRoles)) {
        next('/DefaultContent')
      } else {
        next()
      }
    } else {
      // 没有 token
      if (whiteList.includes(to.path)) {
        next()
      } else {
        next('/login')
      }
    }
    NProgress.done()
  })

  // 路由后置守卫
  router.afterEach(() => {
    NProgress.done()  // 结束进度条
  })

  // 路由错误处理
  router.onError((error) => {
    console.error('路由错误:', error)
    NProgress.done()  // 确保进度条结束
  })
}

// 修改权限检查函数以支持多种路由配置格式
function checkRoutePermission(path, roles) {
  console.log('检查路径:', path);
  console.log('用户角色:', roles);
  
  // 如果包含平台管理员角色，直接返回 true
  if (roles.includes('平台管理员')) {
    return true;
  }

  const hasLegalPerson = roles.includes('法人');
  const hasCompanyAdmin = roles.includes('企业管理员');

  // 调试日志
  console.log('当前路径:', path);
  console.log('当前角色:', roles);
  console.log('是否有法人角色:', hasLegalPerson);
  console.log('是否有企业管理员角色:', hasCompanyAdmin);
  
  // 法人和企业管理员双角色时，排除两个角色共同的exclude路由
  if (hasLegalPerson && hasCompanyAdmin) {
    const legalPersonExclude = roleRoutes['法人'].exclude;
    const companyAdminExclude = roleRoutes['企业管理员'].exclude;
    const commonExclude = legalPersonExclude.filter(route => 
      companyAdminExclude.includes(route)
    );
    return !commonExclude.includes(path);
  }

  // 单角色 - 法人
  if (hasLegalPerson && !hasCompanyAdmin) {
    return !roleRoutes['法人'].exclude.includes(path);
  }

  // 单角色 - 企业管理员
  if (!hasLegalPerson && hasCompanyAdmin) {
    return !roleRoutes['企业管理员'].exclude.includes(path);
  }

  // 其他角色
  return roles.some(role => {
    if (Array.isArray(roleRoutes[role])) {
      return roleRoutes[role].includes(path);
    }
    return false;
  });
}   
